export default __webpack_public_path__ + "static/garret-516f18ba2d352ebfe703c56bcb079f91.jpg";